import { render, staticRenderFns } from "./CreatePickup.vue?vue&type=template&id=48bdc47c"
import script from "./CreatePickup.vue?vue&type=script&lang=js"
export * from "./CreatePickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports